// extracted by mini-css-extract-plugin
export default {"container":"Address_container__eX2zQ","title":"Address_title__uef4p"};